import { useState } from 'react'
import { SlidersHorizontal, Router, AlertTriangle, Shield, Languages } from 'lucide-react'
import AIRouterPage from './AIRouterPage'
import AIPriorityPage from './AIPriorityPage'
import AISlaPage from './AISlaPage'
import AITranslatorPage from './AITranslatorPage'

const tabs = [
  { id: 'router', label: 'Email Router', icon: Router },
  { id: 'priority', label: 'Priority Classifier', icon: AlertTriangle },
  { id: 'translator', label: 'AI Translator', icon: Languages },
  { id: 'sla', label: 'SLA Policies', icon: Shield },
]

export default function AISettingsPage() {
  const [activeTab, setActiveTab] = useState('router')

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div>
        <div className="flex items-center space-x-3 mb-1">
          <SlidersHorizontal className="w-6 h-6 text-gray-400" />
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight">AI Settings</h1>
        </div>
        <p className="text-sm text-gray-500 ml-9">Configure how AI classifies, routes, and prioritizes your support emails</p>
      </div>

      {/* Tab Switcher */}
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm">
        <div className="flex border-b border-gray-100">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex items-center justify-center space-x-2.5 px-4 py-3.5 text-[13px] font-medium transition-all relative ${
                activeTab === tab.id
                  ? 'text-gray-900'
                  : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <tab.icon className={`w-4 h-4 ${activeTab === tab.id ? 'text-amber-500' : ''}`} />
              <span>{tab.label}</span>
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-4 right-4 h-0.5 bg-amber-400 rounded-t-full" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'router' && <AIRouterPage />}
      {activeTab === 'priority' && <AIPriorityPage />}
      {activeTab === 'translator' && <AITranslatorPage />}
      {activeTab === 'sla' && <AISlaPage />}
    </div>
  )
}
